import React from 'react';
import Box from '@mui/material/Box';

export default function PaymentTypeButton({
  icon,
  label,
  selected,
  feeText,
  onClick,
  ariaLabel,
  dataAction,
}) {
  return (
    <Box
      component="button"
      data-css-selector="payment type button"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#fff',
        color: 'var(--font-color-primary)',
        width: '100%',
        px: 2.5,
        py: 2,
        border: 2,
        borderRadius: 2,
        textAlign: 'left',
        whiteSpace: 'normal',
        m: 0,
        borderColor: selected
          ? 'var(--primary-color)'
          : 'var(--border-color-primary)',
        cursor: 'pointer',
        '&:hover': {
          bgcolor: '#fff',
          color: 'var(--font-color-primary)',
        },
        '@media (max-width:420px)': {
          height: 100,
          p: 1.5,
        },
      }}
      aria-label={ariaLabel}
      data-action={dataAction}
      onClick={onClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', color: 'rgba(51, 51, 51, 0.54)', mr: 1 }}>
          {icon}
        </Box>
        <Box>{label}</Box>
      </Box>
      <Box
        sx={{ fontSize: 12, lineHeight: 1.4, mt: '6px', color: 'rgba(51, 51, 51, 0.54)' }}
      >
        {feeText}
      </Box>
    </Box>
  );
}
